/**
 * Async bootstrap is required for webpack Module Federation so the shared
 * scope (@angular/*, rxjs) initializes before the shell application starts.
 */
import('./bootstrap').catch(err => console.error(err));
